import { useEffect, useState } from "react";
import { getAccountInvoicesAsync } from "../../../../../services/invoiceService";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { getCurrencyAmount } from "./../../../../../utils/stringUtils";
import { Link } from "react-router-dom";
import Pagination from "../../../../../components/common/Pagination";
import Table from "../../../../../components/common/Table";
import moment from "moment";

const InvoicesTable = ({ id, columns, tableOptions, onChange }) => {
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchInvoices = async () => {
      setIsLoading(true);

      const response = await getAccountInvoicesAsync(id, tableOptions);
      const { result, page, total_count } = response;

      const data = result.map((item) => {
        const invoice = (
          <div className="flex items-center">
            {item.is_paid && (
              <div className="mr-3">
                <div className="bg-green-500 border-0 px-3 inline rounded-md">
                  <span className="text-xs text-white">Paid</span>
                </div>
              </div>
            )}
            <Link
              className="text-gray-500 hover:text-blue-500"
              to={`/invoice/${item.id}`}
              target="_blank"
            >
              {item.invoice_number}
            </Link>
          </div>
        );

        const amount = getCurrencyAmount(item.amount);
        const period_start = moment(item.period_start).format("MMM DD, yyyy");
        const period_end = moment(item.period_end).format("MMM DD, yyyy");

        const due_date = item.due_date
          ? moment(item.due_date).format("MMM DD, yyyy")
          : "-";

        const is_posted = item.is_posted ? (
          <IoCheckmarkCircleOutline className="text-green-500 text-lg" />
        ) : (
          "-"
        );

        const created_on = (
          <>
            <p className="text-gray-500">
              {item.is_sent ? moment(item.sent_on).format("LLL") : "-"}
            </p>
          </>
        );

        item["invoice_number"] = invoice;
        item["amount"] = <span>&#8369; {amount}</span>;
        item["period_start"] = period_start;
        item["period_end"] = period_end;
        item["due_date"] = due_date;
        item["is_posted_value"] = item.is_posted;
        item["is_posted"] = is_posted;
        item["created_on"] = created_on;

        return item;
      });

      if (mounted) {
        setInvoices(data);
        setCurrentPage(page);
        setTotalCount(total_count);
        setIsLoading(false);
      }
    };

    fetchInvoices();

    return () => {
      mounted = false;
    };
  }, [id, tableOptions]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={invoices}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default InvoicesTable;
